import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import PhotoIcon from '@mui/icons-material/Photo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import { MenuItem, Popover } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import SvgIcon from '@mui/material/SvgIcon';
import { alpha, styled } from '@mui/material/styles';
import { animated, useSpring } from '@react-spring/web';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from 'src/components/Context/Auth/auth.context';
import Iconify from 'src/components/iconify';
import { PostCreateFolder, PostDeleteFolder, PostRenameFolder } from 'src/components/services/httpServices';
import ModalLayout from 'src/theme/Modal';
import PdfViewerModal from '../Attachments/PdfViewerModal';
import AddAttachmentsModal from './AddAttachmentsModal';
import TreeModal from './TreeModal';

function MinusSquare(props) {
  return (
    <SvgIcon className="folder" fontSize="inherit" style={{ width: 29, height: 29 }} {...props}>
      <FolderIcon />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon className="folder" fontSize="inherit" style={{ width: 29, height: 29, color: props.color }} {...props}>
      <FolderOpenIcon />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  // console.log('props', props);
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 29, height: 29, color: props.color }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      {props.icon == 'rar' || props.icon == 'zip' || props.icon == '7z' || props.icon == 'zipx' ? (
        <FolderZipIcon />
      ) : props.icon == 'pdf' ? (
        <PictureAsPdfIcon />
      ) : props.icon == 'jpg' || props.icon == 'jpeg' || props.icon == 'png' ? (
        <PhotoIcon />
      ) : props.icon == 'xlsx' ? (
        <path d="M 15.875 4 L 15.78125 4.03125 L 4.78125 6.46875 L 4 6.65625 L 4 25.34375 L 4.78125 25.53125 L 15.78125 27.96875 L 15.875 28 L 18 28 L 18 25 L 28 25 L 28 7 L 18 7 L 18 4 Z M 16 6.03125 L 16 25.96875 L 6 23.78125 L 6 8.21875 Z M 18 9 L 26 9 L 26 23 L 18 23 L 18 21 L 20 21 L 20 19 L 18 19 L 18 18 L 20 18 L 20 16 L 18 16 L 18 15 L 20 15 L 20 13 L 18 13 L 18 12 L 20 12 L 20 10 L 18 10 Z M 21 10 L 21 12 L 25 12 L 25 10 Z M 14.15625 11 L 11.875 11.28125 L 10.625 13.96875 C 10.492188 14.355469 10.394531 14.648438 10.34375 14.84375 L 10.3125 14.84375 C 10.234375 14.519531 10.160156 14.238281 10.0625 14 L 9.4375 11.6875 L 7.3125 11.9375 L 7.21875 12 L 9 16 L 7 20 L 9.15625 20.25 L 10.03125 17.78125 C 10.136719 17.46875 10.222656 17.214844 10.25 17.0625 L 10.28125 17.0625 C 10.339844 17.386719 10.378906 17.628906 10.4375 17.75 L 11.78125 20.6875 L 14.21875 21 L 11.5625 15.96875 Z M 21 13 L 21 15 L 25 15 L 25 13 Z M 21 16 L 21 18 L 25 18 L 25 16 Z M 21 19 L 21 21 L 25 21 L 25 19 Z" />
      ) : props.icon == 'docx' ? (
        <path d="M 15 3 A 2 2 0 0 0 14.599609 3.0429688 L 14.597656 3.0410156 L 4.6601562 5.0292969 L 4.6289062 5.0351562 L 4.6269531 5.0371094 A 2 2 0 0 0 3 7 L 3 23 A 2 2 0 0 0 4.6289062 24.964844 L 14.589844 26.957031 L 14.597656 26.958984 A 2 2 0 0 0 15 27 A 2 2 0 0 0 17 25 L 17 5 A 2 2 0 0 0 15 3 z M 19 5 L 19 8 L 23 8 C 23.552 8 24 8.448 24 9 C 24 9.552 23.552 10 23 10 L 19 10 L 19 12 L 23 12 C 23.552 12 24 12.448 24 13 C 24 13.552 23.552 14 23 14 L 19 14 L 19 16 L 23 16 C 23.552 16 24 16.448 24 17 C 24 17.552 23.552 18 23 18 L 19 18 L 19 20 L 23 20 C 23.552 20 24 20.448 24 21 C 24 21.552 23.552 22 23 22 L 19 22 L 19 25 L 25 25 C 26.105 25 27 24.105 27 23 L 27 7 C 27 5.895 26.105 5 25 5 L 19 5 z M 5.2636719 10 L 7.1230469 10 L 8.0625 16.632812 L 8.1503906 16.632812 L 9.2773438 10 L 10.712891 10 L 11.880859 16.632812 L 11.96875 16.632812 L 12.890625 10 L 14.736328 10 L 12.896484 20 L 11.216797 20 L 10.039062 13.873047 L 9.9511719 13.873047 L 8.7949219 20 L 7.1035156 20 L 5.2636719 10 z" />
      ) : (
        <FilePresentOutlinedIcon />
      )}
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: 'translate3d(20px,0,0)',
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = styled((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />)(
  ({ theme }) => ({
    [`& .${treeItemClasses.iconContainer}`]: {
      '& .close': {
        opacity: 0.8,
        color: theme.palette.primary.main,
      },
      '.folder': {
        color: theme.palette.primary.darker,
      },
    },
    [`& .${treeItemClasses.group}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  })
);

export default function CustomizedTreeView(props) {
  let {
    authState: { userRole },
  } = useContext(AuthContext);
  let { id } = useParams();
  const [selectedPath, setSelectedPath] = useState(null);
  const [selectedRowPath, setSelectedRowPath] = useState(null);
  const [selectedNodeType, setSelectedNodeType] = useState('root');
  const [folderName, setFolderName] = useState('');
  const [open, setOpen] = useState(null);
  const [isFile, setIsFile] = useState(false);
  const [oldName, setOldName] = useState('');
  const [clickPosition, setClickPosition] = useState({ x: null, y: null }); // State to store click position
  const rowClickedHandle = async (node) => {
    console.log('node:', node);

    props?.setSelectedNode(node);
  };

  const renderTreeItems = (nodes) => {
    return nodes?.map((node) => {
      let extSplit = node?.name.split('.');
      let ext = extSplit[extSplit.length - 1];
      return (
        <StyledTreeItem
          onClick={() => rowClickedHandle(node)}
          key={node.path}
          onContextMenu={(event) => handleRightRowClicked(event, node)}
          nodeId={node.path}
          label={node.name}
          endIcon={node?.type == 'directory' ? <MinusSquare /> : <CloseSquare icon={ext} />}
        >
          {Array.isArray(node.children) && node.children.length > 0 && renderTreeItems(node.children)}
        </StyledTreeItem>
      );
    });
  };
  // Inside your component function
  const [rightClickedNode, setRightClickedNode] = useState(null);

  const handleRightClicked = (e, node) => {
    e.preventDefault();
    // e.stopPropagation();
    console.log('Right-clicked!', node);
    setRightClickedNode(node); // Update last right-clicked node
    props.setSelectedPath(node?.path);
    setSelectedPath(node?.path);
    node.type == 'file' ? setIsFile(true) : setIsFile(false);
    setOldName(node?.name);
    setClickPosition({ x: e.clientX, y: e.clientY }); // Store click position
    setOpen(true); // Open popover
  };

  const handleRightRowClicked = (e, node) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('Right-clicked!', node);
    setRightClickedNode(node); // Update last right-clicked node
    props.setSelectedPath(node?.path);
    setSelectedRowPath(node?.path);
    setOldName(node?.name);
    node.type == 'file' ? setIsFile(true) : setIsFile(false);
    setSelectedNodeType('row');
    setClickPosition({ x: e.clientX, y: e.clientY }); // Store click position
    setOpen(true); // Open popover
  };

  const handlePopoverClose = () => {
    setOpen(false); // Close popover
  };

  const createFolder = async () => {
    props.setLoading(true);
    let payload = {
      folderName: folderName,
      path: selectedNodeType == 'row' ? selectedRowPath : selectedPath,
    };

    console.log('payload:', payload);
    var response = await PostCreateFolder(payload);
    console.log('PostResponse:', response);
    if (response.status == 200) {
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setFolderName(''); //
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
    props.setLoading(false);
  };
  const renameFileOrFolder = async () => {
    props.setLoading(true);
    var nameExt = null;
    if (isFile) {
      nameExt = oldName.split('.');
      var ext = nameExt[nameExt.length - 1];
      console.log('nameExt:', nameExt, ext);
    }
    let payload = {
      folderName: isFile == true ? folderName + '.' + nameExt[nameExt.length - 1] : folderName,
      path: selectedNodeType == 'row' ? selectedRowPath : selectedPath,
      isFile: isFile,
      oldName: oldName,
    };

    console.log('payload:', payload);
    var response = await PostRenameFolder(payload);
    console.log('PostResponse:', response);
    if (response.status == 200) {
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setFolderName(''); //
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
    props.setLoading(false);
  };

  const deleteAttachmentFolder = async () => {
    props.setLoading(true);

    let payload = {
      folderName: folderName,
      path: selectedNodeType == 'row' ? selectedRowPath : selectedPath,
      isFile: isFile,
      oldName: oldName,
    };

    console.log('payload:', payload);
    var response = await PostDeleteFolder(payload);
    console.log('PostResponse:', response);
    if (response.status == 200) {
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setFolderName(''); //
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
    }
    props.setLoading(false);
  };
  return (
    <>
      <TreeView
        aria-label="customized"
        // defaultExpanded={['1']}
        defaultCollapseIcon={<PlusSquare />}
        defaultExpandIcon={<MinusSquare />}
        defaultEndIcon={<CloseSquare />}
        sx={{ height: 464, flexGrow: 1, overflowY: 'auto' }}
      >
        <StyledTreeItem
          key={props?.data?.path}
          onContextMenu={(event) => handleRightClicked(event, props?.data)}
          onClick={() => rowClickedHandle(props?.data)}
          nodeId={props?.data?.path}
          label={props?.data?.name}
          endIcon={<MinusSquare />}
        >
          {renderTreeItems(props?.data?.children)}
        </StyledTreeItem>
      </TreeView>
      <Popover
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={
          clickPosition.y !== null && clickPosition.x !== null
            ? { top: clickPosition.y, left: clickPosition.x }
            : undefined
        }
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {!isFile && isFile != 'file' ? (
          <MenuItem>
            {/* <Iconify icon={'pajamas:folder-new'} sx={{ mr: 2 }} /> */}
            <TreeModal
              title="New Folder"
              setFolderName={setFolderName}
              description="Please Enter Folder Name"
              Hit={createFolder}
              icon="pajamas:folder-new"
            />
          </MenuItem>
        ) : null}
        {oldName && oldName != props?.data.name && !isFile && isFile != 'file' ? (
          <MenuItem>
            {/* <Iconify icon={'fluent:rename-16-regular'} sx={{ mr: 2 }} /> */}
            <TreeModal
              title="Rename"
              setFolderName={setFolderName}
              description="Please Enter Name"
              Hit={renameFileOrFolder}
              icon="fluent:rename-16-regular"
              oldName={oldName}
            />
          </MenuItem>
        ) : null}
        {isFile && isFile != 'directory' ? (
          <MenuItem>
            {/* <Iconify icon={'wpf:view-file'} sx={{ mr: 2 }} /> */}
            <PdfViewerModal
              icon="wpf:view-file"
              treeView={true}
              selectedNode={rightClickedNode}
              title="View"
              file={oldName}
            />
          </MenuItem>
        ) : null}
        {isFile && isFile != 'directory' ? (
          <MenuItem onClick={() => props.getAttachment(rightClickedNode)}>
            <Iconify icon={'tabler:file-download'} sx={{ mr: 2 }} />
            Download
          </MenuItem>
        ) : null}

        {!isFile && isFile != 'file' ? (
          <MenuItem>
            {/* <Iconify icon={'material-symbols:upload-file-outline'} sx={{ mr: 2 }} /> */}
            <AddAttachmentsModal
              setMessage={props.setMessage}
              setSaved={props.setSaved}
              setLoading={props.setLoading}
              setOpen={props.setOpen}
              rightClickedNode={rightClickedNode}
              title="Upload File"
              icon="material-symbols:upload-file-outline"
            />
          </MenuItem>
        ) : null}

        {!isFile &&
        isFile != 'file' &&
        rightClickedNode?.children?.length <= 0 &&
        oldName &&
        oldName != props?.data.name ? (
          <MenuItem>
            <ModalLayout
              title="Delete"
              description="Are You Sure you want to Delete?"
              icon="mi:delete"
              treeViews={true}
              Hit={deleteAttachmentFolder}
            />
          </MenuItem>
        ) : null}
      </Popover>
    </>
  );
}
